import React from 'react'
import { useDispatch } from 'react-redux'

import { sendMessages } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useSendTestsInvitationsMutations = () => {
  const dispatch = useDispatch()

  const handleSendInvitations = React.useCallback(
    ({ candidates, projectId, workspaceId }, { onShowSnackbar, onSuccess }) => {
      dispatch(
        sendMessages(
          { candidates, projectId, workspaceId },
          { onShowSnackbar, onSuccess },
        ),
      )
    },
    [dispatch],
  )

  return {
    handleSendInvitations,
  }
}

export const useSendTestsInvitationsModal = (state, handlers) => {
  const { projectId, workspaceId } = state
  const { handleSetCandidate } = handlers

  const handleReset = React.useCallback(() => {
    handleSetCandidate(null)
  }, [handleSetCandidate])

  const { handleClose, handleOpen, isOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleSendInvitations } = useSendTestsInvitationsMutations()

  const handleSendTestsInvitationsModalClose = React.useCallback(() => {
    handleClose()
    handleReset()
  }, [handleClose, handleReset])

  const handleSendTestsInvitationsModalConfirm = React.useCallback(
    ({ candidates }, { onSuccess }) => {
      handleSendInvitations(
        { candidates, projectId, workspaceId },
        {
          onShowSnackbar: handleShowSnackbar,
          onSuccess: () => {
            onSuccess()
            handleReset()
          },
        },
      )
      handleClose()
    },
    [
      projectId,
      workspaceId,
      handleClose,
      handleReset,
      handleSendInvitations,
      handleShowSnackbar,
    ],
  )

  return {
    handleSendTestsInvitationsModalClose,
    handleSendTestsInvitationsModalConfirm,
    handleSendTestsInvitationsModalOpen: handleOpen,
    isSendTestsInvitationsModalOpen: isOpen,
  }
}
